// src/components/SavedAddressesModal/SavedAddressesModal.jsx
import React from "react";
import "./SavedAddressesModal.css";
import { TbHome, TbPlus } from "react-icons/tb";
import { useLanguage } from "../../LanguageProvider";

export default function SavedAddressesModal({
  isOpen,
  onClose,
  addresses = [],
  onSelect,   // mevcut adres seçildiğinde
  onAddNew,   // "Yeni Adres Bilgisi Ekleyin" tıklanınca
}) {
  const { getTranslation } = useLanguage();

  if (!isOpen) return null;

  const handleSelect = (addr) => {
    if (onSelect) onSelect(addr);
  };

  const handleAddNew = () => {
    if (onAddNew) onAddNew();
  };

  return (
    <div className="saved-addresses-overlay">
      <div className="saved-addresses-modal">
        <div className="saved-addresses-header">
          <h2>{getTranslation("savedAddressesTitle")}</h2>
          <button
            type="button"
            className="saved-addresses-close-btn"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <p className="saved-addresses-subtitle">
          {getTranslation("savedAddressesSubtitle")}
        </p>

        <div className="saved-addresses-list">
          {addresses.map((addr) => (
            <button
              key={addr.id}
              type="button"
              className="saved-address-card"
              onClick={() => handleSelect(addr)}
            >
              <div className="saved-address-card-icon">
                <TbHome size={18} />
              </div>
              <div className="saved-address-card-text">
                <span className="saved-address-card-title">
                  {addr.label}
                </span>
                <span className="saved-address-card-detail">
                  {addr.detail || getTranslation("savedAddressesDetailPlaceholder")}
                </span>
              </div>
            </button>
          ))}

          {addresses.length === 0 && (
            <div className="saved-addresses-empty">
              {getTranslation("savedAddressesEmpty")}
            </div>
          )}
        </div>

        <button
          type="button"
          className="saved-addresses-new-btn"
          onClick={handleAddNew}
        >
          <TbPlus size={18} className="saved-addresses-new-icon" />
          <span>{getTranslation("savedAddressesAddNew")}</span>
        </button>
      </div>
    </div>
  );
}